import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { DialogTitle } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

interface CommonDialogProps {
  open: boolean;
  title: string;
  children: JSX.Element;
  acceptButtonName?: string;
  onAccept?: () => void;
  closeButtonName?: string;
  onClose?: () => void;
}

export const CommonDialog = (props: CommonDialogProps): JSX.Element => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleAccept = () => {
    if (!props.onAccept) {
      return;
    }
    props.onAccept();
  };

  const handleClose = () => {
    setDialogOpen(false);
    if (!props.onClose) {
      return;
    }
    props.onClose();
  };

  useEffect(() => setDialogOpen(props.open), [props.open]);

  const createSubmitButton = () => {
    if (props.acceptButtonName && props.onAccept) {
      return (
        <Button variant="contained" onClick={handleAccept}>
          {props.acceptButtonName}
        </Button>
      );
    }
  };

  const createCancelButton = () => {
    if (props.closeButtonName && props.onClose) {
      return (
        <Button variant="outlined" onClick={handleClose}>
          {props.closeButtonName}
        </Button>
      );
    }
  };

  return (
    <Dialog open={dialogOpen} onClose={handleClose}>
      <div>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>{props.children}</DialogContent>
        <DialogActions className="flex">
          {createCancelButton()}
          {createSubmitButton()}
        </DialogActions>
      </div>
    </Dialog>
  );
};
